import { render } from "./DemoModal.vue?vue&type=template&id=fa31ff26&scoped=true&ts=true"
import script from "./DemoModal.vue?vue&type=script&lang=ts"
export * from "./DemoModal.vue?vue&type=script&lang=ts"

import "./DemoModal.vue?vue&type=style&index=0&id=fa31ff26&lang=postcss&scoped=true"
/* custom blocks */
import block0 from "./DemoModal.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa31ff26"]])

export default __exports__